import { render, staticRenderFns } from "./3.vue?vue&type=template&id=19b22584&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b22584')) {
      api.createRecord('19b22584', component.options)
    } else {
      api.reload('19b22584', component.options)
    }
    module.hot.accept("./3.vue?vue&type=template&id=19b22584&", function () {
      api.rerender('19b22584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/add-routes/alternates/3.vue"
export default component.exports